'use strict';
const attr = require('../dom/attr'),
	css = require('../dom/css');
module.exports = function createReorderBounds(stageDOM) {
	const result = stageDOM.ownerDocument.createElement('div');
	attr(result, {
		'data-mapjs-role': 'reorder-bounds',
		'class': 'mapjs-reorder-bounds'
	});
	css(result, {position: 'absolute', display: 'none'});
	stageDOM.append(result);
	return result;
};

